import { render, staticRenderFns } from "./my-subjects-modal.vue?vue&type=template&id=20ed39d4&scoped=true"
import script from "./my-subjects-modal.vue?vue&type=script&lang=js"
export * from "./my-subjects-modal.vue?vue&type=script&lang=js"
import style0 from "./my-subjects-modal.vue?vue&type=style&index=0&id=20ed39d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ed39d4",
  null
  
)

export default component.exports